import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './hooks/Auth';

import { BrowserRouter, Route, Routes } from 'react-router'
import GalleryPage from './Pages/GalleryPage';
import Login from './Pages/Login';
import Register from './Pages/Register';
import MainPage from './Pages/MainPage';
import ProfilePage from './Pages/ProfilePage';
import PostDisplay from './Pages/PostDisplay';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<App />}/>
          <Route path='/login' element={<Login/>}/>
          <Route path='/register' element={<Register/>}/>
          <Route path='/gallery' element={<GalleryPage/>}/>
          <Route path='/editor' element={<MainPage/>}/>
          <Route path='/profile' element={<ProfilePage/>}/>
          <Route path="/post" element={<PostDisplay/>}/>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
